const toNumberOrNull = value =>
  value ? (Number(value) ? Number(value) : null) : null

export default {
  toNumberOrNull
}
